/**
 *  Behavior error
 *
 *  @class BehaviorError
 *  @extends Error
 */
class BehaviorError extends Error {
  constructor(debugMessage) {
    let errorCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    let errorData = arguments.length > 2 ? arguments[2] : undefined;
    let cause = arguments.length > 3 ? arguments[3] : undefined;
    super(debugMessage, cause ? {
      cause
    } : undefined);
    if (errorData) {
      this.prodData = errorData;
    }
    Error.captureStackTrace(this, this.constructor);
    this.name = 'BehaviorError';
    this.statusCode = errorCode;
    this.debugMessage = debugMessage;
    this.messageKey = 'nativebehavior_error';
    this.logLevel = 'error';
    if (cause !== null && cause !== void 0 && cause.stack) {
      this.stack = "".concat(this.stack, "\n\nCaused by:\n").concat(cause.stack);
    }
  }
}
module.exports = BehaviorError;